import { type ReactElement } from 'react'
import { type TDataTableProps } from './types'
import { toGridTemplateColumn } from './toGridTemplateColumn'
import { TableContent } from './TableContent'
import styles from './table.module.css'
import { TDataTablePagination } from './Pagination'

export const TDataTable = <T extends Record<string, unknown> | unknown[]>({
  pagination,
  pinFirstColumn,
  pinLastColumn,
  rowBorders,
  striped = true,
  highlightRowOnHover,
  ...props
}: TDataTableProps<T>): ReactElement => {
  const gridTemplateColumns = props.columns.map(toGridTemplateColumn).join(' ')

  if (!props.nestedTable) {
    return (
      <div className='flex h-full flex-1 flex-col justify-between'>
        <div className={styles.tableWrapper} tabIndex={0}>
          <div
            className={styles.table}
            data-highlight-row-on-hover={highlightRowOnHover}
            data-pin-first-column={pinFirstColumn}
            data-pin-last-column={pinLastColumn}
            data-row-borders={rowBorders}
            data-striped-rows={striped || undefined}
            style={{
              gridTemplateColumns,
            }}
          >
            <TableContent {...props} pinFirstColumn={pinFirstColumn} pinLastColumn={pinLastColumn} />
          </div>
        </div>
        <TDataTablePagination pagination={pagination} />
      </div>
    )
  }

  return <TableContent {...props} pinFirstColumn={pinFirstColumn} pinLastColumn={pinLastColumn} />
}
